import { useTranslations } from 'next-intl';
import { CheckIcon } from '@heroicons/react/24/outline';

import { useDeclineInvitationMutation } from '@keymono/apis';

import { ActionContainer } from './ActionContainer';

interface IDeclineInvitationCTAProps {
  id: string;
}

/**
 * -----------------------------------------------------------------------------
 * Provides an action that allows a user to decline/reject and invitation for
 * joining an org.
 */
export function DeclineInvitationCTA({ id }: IDeclineInvitationCTAProps) {
  const t = useTranslations('Invitations.decline');

  const { data, isLoading, error, declineOrganizationInvitation } =
    useDeclineInvitationMutation({ id });

  const handleClick = () => {
    declineOrganizationInvitation({ id });
  };

  return (
    <ActionContainer
      actionType="secondary-action"
      errorMessage={error?.message || null}
      Icon={CheckIcon}
      isLoading={isLoading}
      isSuccess={!!data}
      loadingMessage={t('loading')}
      successMessage={t('success')}
      onActionPress={handleClick}
      title={t('title')}
      titleRetry={t('retry')}
    />
  );
}
